export default __webpack_public_path__ + "static/media/acps_banner.f17faa33.png";